<template>
	<AppModal class="text-color-standard" :open="open" title="Bekræft sletning">
		<p>{{ message }}</p>
		<div class="mt-6 flex justify-end gap-4">
			<button
				type="button"
				class="group gray-button justify-self-start dark:border-gray-600"
				@click="emit('cancel')"
			>
				{{ cancelText ?? 'Annullér' }}
			</button>
			<button
				type="button"
				class="group justify-self-start dark:border-gray-600"
				:class="danger ? 'red-button' : 'green-button'"
				@click="emit('confirm')"
			>
				{{ acceptText ?? 'Bekræft' }}
			</button>
		</div>
	</AppModal>
</template>

<script setup lang="ts">
import AppModal from '../AppModal.vue';

defineProps<{ open: boolean; message: string; cancelText?: string; acceptText?: string; danger?: boolean }>();

const emit = defineEmits<{
	(e: 'confirm'): void;
	(e: 'cancel'): void;
}>();
</script>
